export const routeSlugs = {
  sk: {
    prefixes: {
      election: "volby",
    },
    pages: {
      introduction: "uvod",
      guide: "navod",
      question: "otazka",
      review: "rekapitulacia",
      result: "vysledok",
      comparison: "porovnanie",
    },
  },
} as const;
